import * as React from 'react'
import './index.scss'
import arrow from '../../images/drop1.svg'
import FormControl from "@material-ui/core/FormControl";
import {createStyles, styled, Theme, withStyles} from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import MenuItem from "@material-ui/core/MenuItem";
import Select from '@material-ui/core/Select';
import {injectIntl, IntlShape} from 'react-intl'
interface IProps {
    total: number,
    recordsPerPage: number,
    currentPage: number,
    onPageChange: (page: number)=>void,
    onRecordsPerPageChange: (value: any) => void,
    intl: IntlShape
}

interface IState {
}

const defaultProps = {
    total: 0,
    recordsPerPage: 20,
    currentPage: 1
}

const recordsOptions = [
    {value: 5, label: '5'},
    {value: 20, label: '20'},
    {value: 50, label: '50'},
    {value: 100, label: '100'},
]

const InputForSelect = withStyles((theme: Theme) =>
    createStyles({
        root: {
            'label + &': {
                marginTop: theme.spacing(2),
            },
        },
        input: {
            width: 20,
            borderRadius: 2,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            textAlign: 'left',
            fontSize: 12,
            padding: '8px 20px 8px 10px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:focus': {
                borderRadius: 2,
                borderColor: '#80bdff',
                boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
            },
        },
    }),
)(InputBase);

const MyMenuItem = styled(MenuItem)({
    minHeight: 0
})

class Pagination extends React.Component<IProps, IState> {
    static defaultProps = defaultProps

    getOption = (value: number) => {
        for(var i in recordsOptions){
            if(recordsOptions[i].value === value){
                return recordsOptions[i]
            }
        }
        return recordsOptions[0]
    }
    onPrev = () => {
        if(this.props.currentPage > 1){
            this.props.onPageChange(this.props.currentPage - 1)
        }
    }
    onPageChange = (page: string) => {
        if(page === '...' || page === String(this.props.currentPage)){
            return;
        }
        this.props.onPageChange(Number(page))
    }
    onNext = () => {
        let {total, recordsPerPage} = this.props
        let page = Math.ceil(total / recordsPerPage)

        if(this.props.currentPage < page){
            this.props.onPageChange(this.props.currentPage + 1)
        }
    }
    getPageItems = () => {
        let {currentPage, total, recordsPerPage} = this.props
        if(total === 0){
            return []
        }
        let page = Math.ceil(total / recordsPerPage)

        let items = []

        // ======
        if(currentPage !== 1 && currentPage - 1 !== 1 && currentPage - 2 !== 1){
            items.push('1')
        }
        if(currentPage - 2 > 1){
            items.push('...')
        }
        if(currentPage - 2 > 0){
            items.push(String(currentPage -2))
        }
        if(currentPage - 1 > 0){
            items.push(String(currentPage -1))
        }

        if(currentPage > 0 && currentPage <= page){
            items.push(String(currentPage))
        }

        if(currentPage + 1 <= page ){
            items.push(String(currentPage + 1))
        }
        if(currentPage + 2 <= page ){
            items.push(String(currentPage + 2))
        }
        if(currentPage + 2 < page - 1 ){
            items.push('...')
        }
        if(currentPage !== page && currentPage + 1 !== page && currentPage +2 !== page){
            items.push(String(page))
        }
        return items
    }
    onRecordsPerPageChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
       localStorage.setItem('S4P_RercodesPerPage', String(event.target.value));
        this.props.onRecordsPerPageChange(event.target.value)
    }
    public render() {
        let {total, recordsPerPage, currentPage, intl} = this.props
        let page = Math.ceil(total / recordsPerPage)
        return (<div className="Pagination">
            <div className="recordsPerPage">
                <span>{intl.formatMessage({id: 'pagiPrefix'})}</span>
                <FormControl className="formControl">
                    <Select
                        value={recordsPerPage}
                        onChange={this.onRecordsPerPageChange}
                        input={<InputForSelect id="page-select" name="recordsPerPage"/>}
                    >
                        {
                            recordsOptions.map((record, i) => {
                                return <MyMenuItem key={`page-record-${record.value}`}
                                                   value={record.value}>{record.label}</MyMenuItem>
                            })
                        }
                    </Select>
                </FormControl>
                <span>{intl.formatMessage({id: 'pagiAfter'})}</span>
            </div>
            <div className="pages">
                {page > 0?
                    <span className={`prevPage ${currentPage <=1 ? 'disabled' : ''}`} onClick={this.onPrev}>
                        <img src={arrow} alt="previous page"/>
                    </span>
                    : null}
                {
                    this.getPageItems().map( (item:string, i:number) => {
                        return <span className={`pageItem ${item === String(currentPage) ? 'current': ''}`}
                                     onClick={()=>this.onPageChange(item)}
                                     key={`pagination-${i}`}>{item}</span>
                    })
                }
                {page > 0?
                    <span className={`nextPage ${currentPage === page ? 'disabled' : ''}`}
                          onClick={this.onNext}>
                        <img src={arrow} alt="next page"/>
                    </span>
                    : null}
            </div>
        </div>);
    }
}

export default injectIntl(Pagination)